<template>
  <div class="e6-form-extend-wrapper">
    <el-form
      :model="formExtend"
      :inline="inline"
      :label-position="labelPosition"
      :label-width="labelWidth"
      :rules="rules"
      ref="formExtend"
    >
      <slot v-bind:forms="localFormExtend.forms"></slot>
      <template v-for="(form, index) in localFormExtend.extends">
        <!-- input类型 -->
        <el-form-item
          v-if="form.type === 'input'"
          v-bind="form.extJson.labelConfig"
          :key="index"
          :prop="'extends.' + index + '.value'"
        >
          <el-input v-model="form.value" v-bind="form.extJson.inputConfig">
            <!-- 前置或者后置内容 -->
            <template
              v-if="typeof form.template === 'object'"
              :slot="form.template.slot"
              >{{ form.template.text }}
            </template>
          </el-input>
        </el-form-item>
        <!-- input类型 end -->
        <!-- data-picker类型 -->
        <el-form-item
          v-if="form.type === 'datePicker'"
          v-bind="form.extJson.labelConfig"
          :key="index"
          :prop="'extends.' + index + '.value'"
        >
          <el-date-picker
            v-model="form.value"
            v-bind="form.extJson.dateConfig"
          ></el-date-picker>
        </el-form-item>
        <!-- data-picker end -->
        <!-- select类型 -->
        <el-form-item
          v-if="form.type === 'select'"
          v-bind="form.extJson.labelConfig"
          :key="index"
          :prop="'extends.' + index + '.value'"
        >
          <el-select v-model="form.value" v-bind="form.extJson.selectConfig">
            <el-option
              v-for="item in form.extJson.options"
              :key="item.key"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- select类型 end -->
        <!-- remote-select类型 -->
        <el-form-item
          v-if="form.type === 'selectRemote'"
          v-bind="form.extJson.labelConfig"
          :key="index"
          :prop="'extends.' + index + '.value'"
        >
          <e6-select-remote
            :value.sync="form.value"
            :remoteApi="form.extJson.remoteSelectConfig"
          ></e6-select-remote>
        </el-form-item>
        <!-- remote-select类型 end -->
        <!-- dynamic-select类型 -->
        <el-form-item
          v-if="form.type === 'selectDynamic'"
          v-bind="form.extJson.labelConfig"
          :key="index"
          :prop="'extends.' + index + '.value'"
        >
          <e6-select-dynamic
            :value.sync="form.value"
            :dynamicApi="form.extJson.dynamicSelectConfig"
          ></e6-select-dynamic>
        </el-form-item>
        <!-- dynamic-select类型 end -->
      </template>
      <div
        class="el-group el-form-item"
        v-if="this.$slots.submit || this.$slots.reset"
      >
        <el-button
          v-if="this.$slots.submit"
          type="primary"
          :loading="submitLoadingState"
          @click="submitForm()"
        >
          <slot name="submit"></slot>
        </el-button>
        <el-button v-if="this.$slots.reset" @click="resetForm()">
          <slot name="reset"></slot>
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import validate from "_private/utils/validate";

export default {
  name: "E6FormExtend",
  props: {
    forms: {
      type: Array,
      default: function() {
        return [];
      }
    },
    rules: {
      type: Object,
      default: function() {
        return {};
      }
    },
    formExtend: {
      type: Object,
      default: function() {
        return {
          extends: [],
          forms: []
        };
      }
    },
    labelWidth: {
      type: String,
      default: "98px"
    },
    inline: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: "right"
    },
    submitLoadingState: {
      type: Boolean,
      default: false
    },
    formClass: {
      type: String,
      default: ""
    }
  },
  computed: {
    localFormExtend() {
      let formExtend = this.formExtend;
      if (formExtend.extends.length) {
        formExtend.extends = formExtend.extends.map(item => {
          if (
            item.extJson &&
            item.extJson.labelConfig &&
            item.extJson.labelConfig.rules &&
            item.extJson.labelConfig.rules.length
          ) {
            item.extJson.labelConfig.rules = item.extJson.labelConfig.rules.map(
              rule => {
                rule.validator = validate[rule.validator];
                return rule;
              }
            );
          }
          return item;
        });
      }
      return this.formExtend;
    }
  },
  methods: {
    submitForm() {
      return new Promise(resolve => {
        this.$refs["formExtend"].validate(valid => {
          this.$emit("submitForm", valid);
          resolve(valid);
        });
      });
    },
    resetForm() {
      this.$refs["formExtend"].resetFields();
      this.$emit("resetForm");
    },
    //触发表单某一项校验
    validateField(prop) {
      this.$refs["formExtend"].validateField(prop);
    }
  }
};
</script>

<style lang="scss" scoped>
.e6-form-extend-wrapper {
  position: relative;
  z-index: 999;
}
</style>
